import { render, staticRenderFns } from "./ReferralGuideDetail.vue?vue&type=template&id=6d0af1e4&scoped=true&"
import script from "./ReferralGuideDetail.vue?vue&type=script&lang=js&"
export * from "./ReferralGuideDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReferralGuideDetail.vue?vue&type=style&index=0&id=6d0af1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0af1e4",
  null
  
)

export default component.exports